import Vue from "vue";
import {
  faShareAlt,
  faArrowDown,
  faPen,
  faTrashAlt,
  faCalculator,
  faLock,
  faMagic,
  faBolt,
  faCubes,
  faCog,
  faCogs,
  faTerminal,
  faGamepad,
  faSort,
  faPaperPlane,
  faTimes,
  faFileAlt,
  faLifeRing,
  faTools,
  faIndustry,
  faCaretRight,
  faCaretDown,
  faWifi,
  faCommentDots,
  faEnvelope,
  faArrowsAlt,
  faCheck,
  faChevronDown,
  faChevronUp,
  faArrowRight,
  faScroll
} from '@fortawesome/free-solid-svg-icons';
import {
  faConnectdevelop
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'

library.add(
  faShareAlt,
  faArrowDown,
  faPen,
  faTrashAlt,
  faCalculator,
  faLock,
  faMagic,
  faBolt,
  faCubes,
  faCog,
  faCogs,
  faTerminal,
  faGamepad,
  faSort,
  faPaperPlane,
  faTimes,
  faFileAlt,
  faLifeRing,
  faTools,
  faIndustry,
  faCaretRight,
  faCaretDown,
  faWifi,
  faCommentDots,
  faEnvelope,
  faConnectdevelop,
  faArrowsAlt,
  faCheck,
  faChevronUp,
  faChevronDown,
  faArrowRight,
  faScroll
);
Vue.component('font-awesome-icon', FontAwesomeIcon);
